import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import PageHeader from './PageHeader';
import { APP_STORE_URL } from '../constants';

const SubscriptionPage = () => {
    const { getFullTranslation } = useLanguage();
    const t = getFullTranslation('subscriptionPage');

    const plans = [
        {
            tag: t.free,
            title: t.freePlan,
            price: '¥0',
            period: t.permanent,
            desc: t.freeDesc,
            features: [t.free1, t.free2, t.free3, t.free4],
            disabled: [t.free5, t.free6, t.free7, t.free8],
            btn: t.freeUse,
            outline: true,
            featured: false,
        },
        {
            tag: t.recommended,
            title: t.monthlyPlan,
            price: '¥12',
            period: t.perMonth,
            desc: t.monthlyDesc,
            features: [t.monthly1, t.monthly2, t.monthly3, t.monthly4, t.monthly5, t.monthly6, t.monthly7, t.monthly8],
            disabled: [],
            btn: t.subscribeNow,
            outline: false,
            featured: true,
        },
        {
            tag: t.bestValue,
            title: t.annualPlan,
            price: '¥99',
            period: t.perYear,
            desc: t.annualDesc,
            features: [t.annual1, t.annual2, t.annual3, t.annual4, t.annual5, t.annual6, t.annual7, t.annual8, t.annual9],
            disabled: [],
            btn: t.subscribeNow,
            outline: true,
            featured: false,
        },
    ];

    const faqs = [
        { q: t.q1, a: t.a1 },
        { q: t.q2, a: t.a2 },
        { q: t.q3, a: t.a3 },
        { q: t.q4, a: t.a4 },
    ];

    return (
        <div>
            <PageHeader title={t.title} subtitle={t.subtitle} />

            <div className="max-w-5xl mx-auto px-6 py-16">
                {/* Pricing Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                    {plans.map((plan, i) => (
                        <div key={i} className={`bg-white rounded-2xl p-8 text-center border-2 transition hover:-translate-y-1 hover:shadow-xl relative
                            ${plan.featured ? 'border-orange-500 bg-gradient-to-b from-orange-50 to-white' : 'border-gray-200'}`}>
                            {plan.featured && (
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-orange-500 text-white px-4 py-1 rounded-full text-xs font-semibold">
                                    {t.mostPopular}
                                </div>
                            )}
                            <div className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-4 ${plan.featured ? 'bg-orange-50 text-orange-500' : 'bg-gray-100 text-gray-500'}`}>
                                {plan.tag}
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.title}</h3>
                            <div className="text-4xl font-extrabold text-gray-900 mb-1">{plan.price}<span className="text-base font-normal text-gray-400">{plan.period}</span></div>
                            <p className="text-gray-400 text-sm mb-6">{plan.desc}</p>

                            <ul className="text-left space-y-3 mb-8">
                                {plan.features.map((f, j) => (
                                    <li key={j} className="flex items-start text-gray-700 text-sm">
                                        <span className="inline-flex items-center justify-center w-5 h-5 bg-orange-500 text-white rounded-full text-[10px] font-bold mr-2.5 flex-shrink-0 mt-0.5">✓</span> {f}
                                    </li>
                                ))}
                                {plan.disabled.map((f, j) => (
                                    <li key={`d${j}`} className="flex items-start text-gray-300 text-sm">
                                        <span className="inline-flex items-center justify-center w-5 h-5 bg-gray-300 text-white rounded-full text-[10px] font-bold mr-2.5 flex-shrink-0 mt-0.5">✓</span> {f}
                                    </li>
                                ))}
                            </ul>

                            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer"
                                className={`block w-full py-3.5 rounded-xl font-semibold text-base transition
                                    ${plan.outline ? 'bg-white text-orange-500 border-2 border-orange-500 hover:bg-orange-50' : 'bg-orange-500 text-white hover:bg-orange-600'}`}>
                                {plan.btn}
                            </a>
                        </div>
                    ))}
                </div>

                {/* FAQ */}
                <div className="mt-16">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-10">{t.faqTitle}</h2>
                    <div className="space-y-4 max-w-3xl mx-auto">
                        {faqs.map((faq, i) => (
                            <div key={i} className="bg-white rounded-xl p-6 border border-gray-200">
                                <div className="font-semibold text-gray-900 mb-2">{faq.q}</div>
                                <div className="text-gray-500 text-sm">{faq.a}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Note */}
                <div className="bg-amber-50 border border-yellow-300 rounded-xl p-5 text-center mt-10">
                    <p className="text-amber-800 text-sm">{t.note}</p>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPage;
